import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import './App.css';
import './Info.css';

import Chan04 from './Chan04.png';

function Info(props) {

  const [tpage, setTpage] = useState(0);
  
  const [t, i18n] = useTranslation();

  const textPage = () =>{
    setTpage(tpage + 1);

    if (tpage > 2) {
      setTpage(0);
    }

  }



  let pagec;
  var pages = tpage;
  switch (pages) {
    case 0:
      pagec =
        <p>
          【このサービスについて（1/4）】<br />
          このサービスはIOSTのアカウントを作ったり、調べたりできるサービスです。わかりやすさを重視して作っています。
          まだまだ小さなこの工房も、みなさんの応援で大きくなって、できることが増えるかもしれません。<br />
          今は「IOSTアカウントをつくる」と「IOSTアカウントをしらべる」の２つの機能のみ提供しています。
        </p>;
      break;
    case 1:
      pagec =
        <p>
          【このサービスについて（2/4）】<br />
          「IOSTアカウントをつくる」ではIOSTアカウントを気軽に作れます。ただ、IOSTのアカウントは１つ作るのに約30 IOSTの費用が必要になります。
          そのコストはAIYAAが負担しています。適宜アカウント作成用のアカウント（費用支払用）にIOSTをチャージする形としますので、
          もしかしたら残高不足で作れない、なんてこともありますが、気長にお待ちください。
        </p>;
      break;
    case 2:
      pagec =
        <p>
          【このサービスについて（3/4）】<br />
          既にアカウントを持っている人はお試しで作るのはやめてください。このサービスは「IOSTを使ってみたいけどアカウント作るの大変だ…」という人のためにあります。<br />
          皆様の善意に期待しております(´・ω・｀)<br />
          なお、アカウント名は一律「chan_99999」の形を取ります。99999の箇所は乱数で発生させた5桁の数字を適宜使っています。
        </p>;
      break;
    default:
      pagec =
        <p>
          【このサービスについて（4/4）】<br />
          「IOSTアカウントをしらべる」ではアカウント名で簡単に残高やiGas/iRam情報、投票先を調べることができます。「このアカウント名はまだ取られていないか」の確認にも使えますね。<br />
          このサービスは＜開発：AIYAA（IOSTノード）＞＜イラスト：ふぁんぞみ＞で提供しています。ノード投票やふぁんぞみさんへの投げ銭、お待ちしております。<br />
          開発者の方、ご連絡お待ちしてます！
        </p>;
      break;
    // null;
  }
  return (
    <div className="Info">
      <div className="PgName">🔰{t('このサービスについて')}</div>
      <button className="Back" onClick={() => props.pg(`menu`)}>{t('もどる')}</button>
      <button className="Go" onClick={textPage}>{t('すすむ')}</button>
      <div className="InfoMsg">
        {pagec}
      </div>
      <div className="InfoImg">
        <img src={Chan04} alt="いらすと ふぁんぞみ" />
      </div>
    </div>
  );
}

export default Info;